import { useState, useEffect, useCallback } from "react";
import NoRecordFound from "../../../components/ui/noRecordFound/NoRecordFound";
import ToastService from "../../../services/toastService/ToastService";

const ModalGroupingTable = ({ data = [] }) => {

    return (
        <>
            <div className="table-title mt-2">
                <h3>Model Grouping</h3>
            </div>

            {data?.length > 0 ? <div className="member-list">
                <div className="content-section">
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Brand Name</th>
                                    <th>Model Name</th>
                                    <th>Rating</th>
                                    <th>Text Value</th>
                                    <th>Cert Number</th>
                                    <th>Cert Suffix</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((item) => (
                                    <tr key={item.sgbpProductId}>
                                        <td>{item.brandName || "N/A"}</td>
                                        <td>{item.modelName || "N/A"}</td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    disabled
                                                    value={item.rating ?? ""}
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    disabled
                                                    defaultValue={item.textValue}
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"

                                                    className="form-control"
                                                    disabled
                                                    value={item.applicationNumber ?? ""}
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    disabled
                                                    defaultValue={item?.certPrefix ?? ""}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : <NoRecordFound />}
        </>
    );
};

export default ModalGroupingTable;